import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  wrapper: {
    marginTop: 12,
    [breakpoints.up('sm')]: {
      marginTop: 16,
    },
  },
}));
